// NotificationModal Component
// Displays details about notification events (user registration, plan purchases, product purchases)

import React from 'react';
import { RevoltModal } from '../../../../../components/RevoltModal';
import './NotificationModal.css';

export function NotificationModal({ isOpen, onClose, notificationData, eventType }) {
  if (!notificationData) return null;

  const renderModalContent = () => {
    if (eventType === 'user_registration') {
      return (
        <div className="notification-details">
          <div className="notification-icon">👤</div>
          <h3>New User Registration</h3>
          <div className="notification-fields">
            <div className="notification-field">
              <label className="notification-field-label">Username:</label>
              <span className="notification-field-value">{notificationData.username || 'N/A'}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Email:</label>
              <span className="notification-field-value">{notificationData.email || 'N/A'}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">User ID:</label>
              <span className="notification-field-value">{notificationData.userId}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Time:</label>
              <span className="notification-field-value">
                {new Date(notificationData.clickedAt || Date.now()).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      );
    }

    if (eventType === 'plan_purchase') {
      return (
        <div className="notification-details">
          <div className="notification-icon">💳</div>
          <h3>Plan Purchase</h3>
          <div className="notification-fields">
            <div className="notification-field">
              <label className="notification-field-label">User ID:</label>
              <span className="notification-field-value">{notificationData.userId}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Plan:</label>
              <span className="notification-field-value">
                {notificationData.planId ? `${notificationData.planId.charAt(0).toUpperCase() + notificationData.planId.slice(1)}` : 'N/A'}
                {notificationData.tierId ? ` (${notificationData.tierId.charAt(0).toUpperCase() + notificationData.tierId.slice(1)})` : ''}
              </span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Billing:</label>
              <span className="notification-field-value">
                {notificationData.billingCycle ? notificationData.billingCycle.charAt(0).toUpperCase() + notificationData.billingCycle.slice(1) : 'N/A'}
              </span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Amount:</label>
              <span className="notification-field-value">
                {notificationData.amount != null ? `$${(notificationData.amount / 100).toFixed(2)}` : 'N/A'}
              </span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Time:</label>
              <span className="notification-field-value">
                {new Date(notificationData.clickedAt || Date.now()).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      );
    }

    if (eventType === 'product_purchase') {
      return (
        <div className="notification-details">
          <div className="notification-icon">🛒</div>
          <h3>Product Purchase</h3>
          <div className="notification-fields">
            <div className="notification-field">
              <label className="notification-field-label">Username:</label>
              <span className="notification-field-value">{notificationData.username || 'N/A'}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Email:</label>
              <span className="notification-field-value">{notificationData.email || 'N/A'}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">User ID:</label>
              <span className="notification-field-value">{notificationData.userId}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Product:</label>
              <span className="notification-field-value">{notificationData.productName || 'N/A'}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Product ID:</label>
              <span className="notification-field-value">{notificationData.productId || 'N/A'}</span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Amount:</label>
              <span className="notification-field-value">
                {notificationData.amount != null ? `$${(notificationData.amount / 100).toFixed(2)}` : 'N/A'}
              </span>
            </div>
            <div className="notification-field">
              <label className="notification-field-label">Time:</label>
              <span className="notification-field-value">
                {new Date(notificationData.clickedAt || Date.now()).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="notification-details">
        <div className="notification-icon">❓</div>
        <h3>Unknown Notification Type</h3>
        <p>Event type: {eventType}</p>
      </div>
    );
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Notification Details"
      closeOnBackdrop={true}
    >
      <div style={{ padding: '20px 0' }}>
        {renderModalContent()}
      </div>
    </RevoltModal>
  );
}